const attachmentUploadTemplate= function(file, assetKey) {
  return (
    `<li class="m-edit-attachment j-temp-attachment s-temp-attachment disabled" data-url=${file.url} > \
      <span class="attachment-wrapper"> \
        <span class="s-attachment-name">\
          <span class="j-attachment-reorder s-reorder-attachment" title="Update asset to reorder attachment" rel="tooltip" data-container="body"> \
            <span class="bff-reorder" aria-label="Reorder attachments" role="img"/> \
            </span> \
           <span class="name-popover" rel="popover" data-placement="top" data-content="<img src=${file.url} style="max-width:230px;max-height:230px;"> \
            ${file.filename} \
           </span> \
           <span class="s-attachment-input hidden" > \
            <input class="j-attachment-name-input s-attachment-name-input" value=${file.filename} type="text"/>\
           </span> \
        </span> \
        <span class="s-attachment-actions" > \
          <span class="bff-trash j-attachment-destroy s-delete-attachment" data-asset-key=${assetKey} data-asset="generic_file" data-asset-name=${file.filename}></span> \
        </span> \
      </span> \
    </li>`
  )
}

export default attachmentUploadTemplate;
